import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-6xl px-5 py-12">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-slate-900 text-white">
                <ShieldCheck className="h-5 w-5" />
              </span>
              <span className="font-display text-lg font-bold tracking-tight text-slate-900">
                DeviceLox
              </span>
            </div>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate-500">
              A simple, trustworthy way to register your device and keep your
              records on file.
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
              Company
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/" className="text-slate-600 hover:text-slate-900">Register a Device</Link></li>
              <li><Link to="/about" className="text-slate-600 hover:text-slate-900">About</Link></li>
              <li><Link to="/contact" className="text-slate-600 hover:text-slate-900">Contact</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
              Legal
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/terms" className="text-slate-600 hover:text-slate-900">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-slate-600 hover:text-slate-900">Privacy Policy</Link></li>
              <li><Link to="/sms-terms" className="text-slate-600 hover:text-slate-900">SMS Terms</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-slate-200 pt-6 text-sm text-slate-400 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} DeviceLox. All rights reserved.</p>
          <p>Consent-first. Duplicate-protected. Records kept private.</p>
        </div>
      </div>
    </footer>
  );
};
